import { LayoutDefault } from '@/hooks/layouts/defaultState';
import { LayoutAction } from '@/hooks/layouts/reducer';
import { createContext, useContext } from 'react';

type LayoutContextType = {
    state: LayoutDefault;
    dispatch: React.Dispatch<LayoutAction>;
};

export const LayoutContext = createContext<LayoutContextType | null>(null);

export const useLayoutState = () => {
    const context = useContext(LayoutContext);
    if (!context) {
        throw new Error('useLayoutState must be used within a LayoutProvider');
    }
    return context;
};
